export default __webpack_public_path__ + "static/media/CyberMenace-FULL.dc587058.mp3";